module.exports = __webpack_public_path__ + "img/RTB.a337689b.png";